import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface EnvelopeCircleCheckIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const EnvelopeCircleCheckIcon: React.FC<EnvelopeCircleCheckIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon envelope-circle-check')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512">
        <path d="M48 128V150.1L220.5 291.7C241.1 308.7 270.9 308.7 291.5 291.7L342.4 249.9C329 273.8 321 301.2 320.1 330.4C281.8 360.3 227.7 359.8 189.1 328.8L48 212.2V384C48 392.8 55.16 400 64 400H331.1C338.8 417.5 348.4 433.7 360.2 448H64C28.65 448 0 419.3 0 384V128C0 92.65 28.65 64 64 64H448C483.3 64 512 92.65 512 128V160.7C506.7 160.2 501.4 160 496 160C476.1 160 458.6 163 441.4 168.6L464 150.1V128C464 119.2 456.8 112 448 112H64C55.16 112 48 119.2 48 128zM640 336C640 415.5 575.5 480 496 480C416.5 480 352 415.5 352 336C352 256.5 416.5 192 496 192C575.5 192 640 256.5 640 336zM540.7 292.7L480 353.4L451.3 324.7C445.1 318.4 434.9 318.4 428.7 324.7C422.4 330.9 422.4 341.1 428.7 347.3L468.7 387.3C474.9 393.6 485.1 393.6 491.3 387.3L563.3 315.3C569.6 309.1 569.6 298.9 563.3 292.7C557.1 286.4 546.9 286.4 540.7 292.7H540.7z" />
      </svg>
    </Tooltip>
  );
};
